export const adx = '//g.delfi.lt/glt/c/delfi-js/delfi-adx.js';
